import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import sources10 from "./components/sources-10";
import sources15 from "./components/sources-15";
import sources20 from "./components/sources-20";
import sources25 from "./components/sources-25";

const principle: Slide = {
  description:
    "Play with the number of sources and the frequency controls to plot the pressure level maps calculated using the pressure matching algorithm.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 6],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Sound zones",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    lineHeight: "22px",
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "controlsToggleExtraContent",
              options: {
                controls: [
                  {
                    type: "button",
                    options: {
                      label: "Number of sources",
                      labelPosition: "left",
                    },
                    items: [{ name: "10" }, { name: "15" }, { name: "20" }, { name: "25" }],
                  },
                  {
                    type: "button",
                    options: {
                      label: "Frequency",
                      labelPosition: "left",
                    },
                    items: [{ name: "300 Hz" }, { name: "600 Hz" }, { name: "1 kHz" }],
                  },
                ],
                controlsPosition: "bottom",
                extraContent: [[], [], [], []],
                components: [sources10, sources15, sources20, sources25],
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
